<template>
  <modal-sheet ref="sheet">
    <editor @logged-in="loggedIn" />
    <b-button
      variant="cancel"
      class="mt-2"
      block
      @click.prevent="$refs.sheet.hide()">
      {{ $t('common.cancel') }}
    </b-button>
  </modal-sheet>
</template>
<script>
import editor from "vue-template/public/editors/LoginEditor";

export default {
  components: {
    editor
  },

  methods: {
    show() {
      this.$refs.sheet.show();
    },

    loggedIn(result) {
      this.$refs.sheet.hide();
      this.$emit('logged-in', result);
    }
  }
};
</script>
